<ng-container [ngSwitch]="summaryTopic">
  <ng-container *ngSwitchCase="'device'">
    <div class="grid">
      <div class="col-6 md:col-2">
        <share-stat-card
          icon="pi pi-cog"
          label="Services Configured"
          color="blue"
          [value]="summaryData?.configured"
        ></share-stat-card>
      </div>
      <div class="col-6 md:col-2">
        <share-stat-card
          icon="pi pi-question-circle"
          label="Unprovisioned"
          color="orange"
          [value]="summaryData?.available"
        ></share-stat-card>
      </div>
      <div class="col-6 md:col-2">
        <share-stat-card
          icon="pi pi-file-invoice"
          label="Billed"
          color="teal"
          [value]="summaryData?.billed"
        ></share-stat-card>
      </div>
      <div class="col-6 md:col-2">
        <share-stat-card
          icon="pi pi-bell"
          label="Notified"
          color="navy"
          [value]="summaryData?.notified"
        ></share-stat-card>
      </div>
      <div class="col-6 md:col-2">
        <share-stat-card
          icon="pi pi-check-circle"
          label="Devices Authorised"
          color="brand"
          [value]="summaryData?.configured"
        ></share-stat-card>
      </div>
      <div class="col-6 md:col-2">
        <share-stat-card
          icon="pi pi-desktop"
          label="Total Devices"
          color="blue"
          [value]="summaryData?.total"
        ></share-stat-card>
      </div>
    </div>
  </ng-container>
  <ng-container *ngSwitchCase="'region'">
    <!-- Map placeholder — rendered by parent component -->
  </ng-container>
</ng-container>
